import { render, staticRenderFns } from "./upDataID.vue?vue&type=template&id=0826438c&scoped=true"
import script from "./upDataID.vue?vue&type=script&lang=js"
export * from "./upDataID.vue?vue&type=script&lang=js"
import style0 from "./upDataID.vue?vue&type=style&index=0&id=0826438c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0826438c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0826438c')) {
      api.createRecord('0826438c', component.options)
    } else {
      api.reload('0826438c', component.options)
    }
    module.hot.accept("./upDataID.vue?vue&type=template&id=0826438c&scoped=true", function () {
      api.rerender('0826438c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/upDataID/upDataID.vue"
export default component.exports